export const blockIconsPlacesRoofing = (
	<span className='material-symbols-outlined'>roofing</span>
);
